/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import { IconDeviceFloppy } from '@tabler/icons-react';
import { Button, Group, LoadingOverlay, Paper, Space } from '@mantine/core';
import { useEffect, useState } from 'react';
import { showNotification } from '@mantine/notifications';
import { Table } from 'antd';
import { FilterData, PackagingFormSearchFilter } from './PackagingFormSearchFilter';
import { PackagingType } from '../../../../../../../models/core/packaging.type';
import { SessionStorageKey } from '../../../../../../../utils/constants.utils';
import packagingsService from '../../../../../../../services/core/packaging.service';
import TableCellEllipsis from '../../../../../../../components/core/TableCellEllipsis/TableCellEllipsis';

type FormViewProps = {
  itemsIdList: number[];
  idEntidade: number | undefined;
  callback(item: PackagingType | null, action: string, confirmed: boolean): void;
};

export default function PackagingFormSearch(props: FormViewProps) {
  const [data, setData] = useState<PackagingType[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState<PackagingType[]>([]);

  const handleSubmit = () => {
    props.callback(selectedData?.[0] || null, 'callback', true);
  };

  const clear = () => {
    sessionStorage.removeItem(SessionStorageKey.PackagingSearch);
    setData([]);
  };

  const filter = async (inputFilterData: FilterData) => {
    try {
      setLoading(true);
      const result = await packagingsService.search({
        residuoAcondicionamento: inputFilterData?.residuoAcondicionamento || null,
        limit: 1000,
        offset: 0,
      });
      sessionStorage.setItem(SessionStorageKey.PackagingSearch, JSON.stringify(result));
      setData(result);
    } catch (error: any) {
      showNotification({
        title: `Entidade - ${!props.idEntidade ? 'Adicionar' : 'Editar'}`,
        message: error?.isBusinessException
          ? error.description
          : 'Não foi possível pesquisar acondicionamentos.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: PackagingType[]) => {
      setSelectedData(selectedRows);
    },
    getCheckboxProps: (record: PackagingType) => ({
      disabled: props.itemsIdList.includes(record.idResiduoAcondicionamento),
      name: record.idResiduoAcondicionamento.toString(),
    }),
  };

  useEffect(() => {
    const cacheResult = JSON.parse(
      sessionStorage.getItem(SessionStorageKey.PackagingSearch) || '[]'
    ) as PackagingType[];

    if (cacheResult.length > 0) {
      setData(cacheResult);
    } else {
      filter({ residuoAcondicionamento: '' });
    }
  }, []);

  return (
    <div>
      <PackagingFormSearchFilter filter={filter} clear={clear} loading={loading} />
      <div style={{ position: 'relative' }}>
        <LoadingOverlay visible={loading} />
        <Paper shadow="xs" p="md" withBorder>
          <Table
            showSorterTooltip={false}
            size="small"
            dataSource={data}
            columns={[
              {
                title: 'Acondicionamento',
                key: 'residuoAcondicionamento',
                dataIndex: 'residuoAcondicionamento',
                sorter: (a: PackagingType, b: PackagingType) =>
                  a.residuoAcondicionamento.localeCompare(b.residuoAcondicionamento),
              },
              {
                title: 'Descrição',
                key: 'descricao',
                sorter: (a: PackagingType, b: PackagingType) => {
                  return (a.descricao || '').localeCompare(b.descricao || '');
                },
                render: (row: PackagingType) => (
                  <TableCellEllipsis label={row?.descricao} numberOfChars={25} toolTipWidth={300} />
                ),
              },
            ]}
            rowSelection={{ type: 'radio', ...rowSelection }}
            rowKey={(item: PackagingType) => item.idResiduoAcondicionamento}
            pagination={{
              pageSizeOptions: [10, 25, 50],
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
            }}
          />
        </Paper>
        <Space h="xl" />
        <Group justify="right">
          <Button leftSection={<IconDeviceFloppy size={18} />} onClick={handleSubmit}>
            Salvar
          </Button>
        </Group>
      </div>
    </div>
  );
}
